import adminPage from './admin.vue';
import { canAccessDevAdminTabs } from '@enums/feature-flags';

const routes = [
  {
    path: '/admin',
    id: 'admin',
    omitFromNav: true,
    component: adminPage,
    linkText: 'navBar.admin',
    meta: { requiresRole: 'adminRoles', requiresRoleFromState: true },
    children: [
      // Default route to ensure that all '/admin' requests are redirected to the '/admin/user-roles'.
      {
        path: '',
        name: 'admin',
        redirect: () => {
          return {
            name: 'user-roles',
          };
        },
      },
      {
        path: 'user-roles',
        name: 'user-roles',
        index: 0,
        meta: { requiresRole: 'adminRoles', requiresRoleFromState: true },
      },
      {
        path: 'feature-toggler',
        name: 'feature-toggler',
        index: 1,
        meta: {
          requiresRole: 'adminRoles',
          requiresRoleFromState: true,
          featureFlag: canAccessDevAdminTabs,
        },
      },
      {
        path: 'diagnostics/workpackage/:workpackageId',
        name: 'diagnostics',
        id: 'diagnostics',
        index: 2,
        meta: {
          requiresRole: 'adminRoles',
          requiresRoleFromState: true,
          featureFlag: canAccessDevAdminTabs,
          selectedWorkpackageRequired: true,
        },
      },
      {
        path: 'translation-editor',
        name: 'translation-editor',
        index: 3,
        meta: {
          requiresRole: 'adminRoles',
          requiresRoleFromState: true,
          featureFlag: canAccessDevAdminTabs,
        },
      },
      {
        path: 'audit',
        name: 'audit',
        index: 4,
        meta: {
          requiresRole: 'adminRoles',
          requiresRoleFromState: true,
          featureFlag: canAccessDevAdminTabs,
        },
      },
    ],
  },
];

export default routes;
